module.exports = __webpack_public_path__ + "img/pro_one_4.ba965253.jpg";